import { store } from "@betacrew/jars-flux";
import { all, put, select, takeLatest } from "redux-saga/effects";
import { componentKey, setLoadingState, setSumOfAllBoxAmount } from "./SumOfAllBoxAmountSlice";
import { PAGE_STATE } from "../../../constants/constants";
import SubmitFormsDataService from "../../../../../services/SubmitFormsDataService";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { setSumOfAllBoxAmountModalOpen } from "../FormListingSlice";

export const { sumOfAllBoxAmounts } = {
    sumOfAllBoxAmounts: (payload) => {
        return {
            type: "SUM_OF_ALL_BOX_AMOUNT",
            payload
        }
    },
}

function* sumOfAllBoxAmountsAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }))

        const { payerId, taxYearId, formId, Corrected, status } = action?.payload;

        const response = yield SubmitFormsDataService.getSumAmountBoxDetail(payerId, taxYearId, formId, Corrected, status);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setSumOfAllBoxAmount(Data))
        } else {
            yield put(addNotifications({ heading: "Failed to get sum of all box amount", message: Message }));
            yield put(setSumOfAllBoxAmountModalOpen(false))
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get sum of all box amount", message: error?.response?.data?.Message }));
        yield put(setSumOfAllBoxAmountModalOpen(false))
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(sumOfAllBoxAmounts().type, sumOfAllBoxAmountsAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);